import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs-compat';
import { configuration } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CCDAService {

  constructor(private http: HttpClient) { }
  generateCDA_DirectMessage(formdata: any, Messagetype: string): Observable<any> {
    const posteddata = {
      patientId: formdata.patientId,// sessionStorage.getItem("patientId"),
      encounterid: formdata.encounterid,// sessionStorage.getItem("encounterid"),
      userid: formdata.userid,// encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      dnisections: formdata.SectionswithComma,// SectionsList
      CCDAType: Messagetype
    };
    return this.http.post<any>(`${configuration.clinicapiUrl + 'Encounter/GetCCDAMessage'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
    //  http://localhost:52622/api/Encounter/GetCCDAMessage const patientId: number=  parseInt(sessionStorage.getItem("patientId"));
    // const encounterID:string=sessionStorage.getItem("encounterid");
    //   return this.http.get<any>(
    //     `${configuration.clinicapiUrl + 'Encounter/GetCCDAMessage'}?patientId=${patientId}&&encounterid=${encounterID}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);


  }
  GetdatafromCCDA(ccdaxml: string): Observable<any> {
    const posteddata = {
      inputdata: ccdaxml
    };
    return this.http.post<any>(`${configuration.clinicapiUrl + 'Encounter/GetCCDAReconsile'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  uploadCDAFile(url: string, file: any): Observable<HttpEvent<any>> {
    let formData = new FormData();
    formData.append('ccdafile', file);
    return this.http.post<any>(
      `${configuration.clinicapiUrl + 'Encounter/ValidateCCDA'}`
      , formData, {
      headers: new HttpHeaders(
        {
          'Accept': '*/*',
          // 'Content-Type': 'multipart/form-data',
          'Access-Control-Allow-Origin': '*',
          // 'Authorization': 'Bearer ' + localStorage.getItem('userToken')
        })
    });


    return this.http.post<any>(url
      , formData, {
      headers: new HttpHeaders(
        {
          'Accept': '*/*',
          'No-Auth': 'True',
          'Content-Type': 'multipart/form-data',
          'Access-Control-Allow-Origin': 'http://localhost:4200 always;',
          // 'Authorization': 'Bearer ' + localStorage.getItem('userToken')
        })
    });



    /*
        let params = new HttpParams();    
        const options = {
          params: params,
          reportProgress: true,
          headers: new HttpHeaders({ 'Access-Control-Allow-Origin': '*', 'No-Auth': 'True' })
        };    
        const req = new HttpRequest('POST', url, formData, options);
        return this.http.request(req);
        */
  }

  PatientActiveData_Reconsolation(PatientId: string): Observable<any> {

    return this.http.get<any>(`${configuration.clinicapiUrl + 'Encounter/PatientActiveData_Reconsolation'}?patientid=${PatientId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  AddPatientRecordRequest(formdata: any): Observable<any> {
    const posteddata = {
      ID: '0',
      PatientId: formdata.patientId,
      encounters: formdata.encounterid,
      DocumentType: formdata.MessageType,
      CreatedBy: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      Sections: formdata.SectionswithComma,
      ReferralNote: formdata.ReferralNote
      // Status: '',
      // ActionDone: ''
    }

    return this.http.post<any>(`${configuration.clinicapiUrl + 'Encounter/AddPatientRecordRequest'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  GetPatientRecordRequest(PatientId: string, ID: string = '0'): Observable<any> {
    return this.http.get<any>(`${configuration.clinicapiUrl + 'Encounter/GetPatientRecordRequest'}?patientid=${PatientId}&&ID=${ID}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  DeletePatientRecordRequest(ID: string): Observable<any> {
    return this.http.delete<any>(`${configuration.clinicapiUrl + 'Encounter/DeletePatientRecordRequest'}?ID=${ID}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  AddCDAReconsilationData(inputdata: any): Observable<any> {
    const posteddata = {
      inputdata: JSON.stringify(inputdata)
    }
    return this.http.post<any>(`${configuration.clinicapiUrl + 'Encounter/AddCDAReconsilationData'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  AddClinicalDataExport_CDA(formdata: any): Observable<any> {
    const inputdata = {
      ID: '0',
      occuranceType: formdata.Occurance,
      RecurringFrom: formdata.RecurringFrom,
      RecurringTo: formdata.RecurringTo,
      CreatedBy: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      PatSelection: formdata.PatientType,
      PatientList: formdata.PatientList.join(','),
      ExportType: formdata.ExportType,
      ExportDate: formdata.ExportDate,
      ExportTime: formdata.ExportTime,
      RecurringType: formdata.RecurringType,
      RecurringDate: formdata.RecurringDate,
      ProviderType: formdata.ProviderType,
      ProviderList: formdata.ProviderList,

    }
    const posteddata = {
      inputdata: JSON.stringify(inputdata)
    };

    return this.http.post<any>(`${configuration.clinicapiUrl + 'Encounter/AddClinicalDataExport_CDA'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  GetClinicalDataExport(id: string): Observable<any> {
    return this.http.get<any>(`${configuration.clinicapiUrl + 'Encounter/GetClinicalDataExport'}?id=${id}&&FacilityId=${sessionStorage.getItem("FacilityId")}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  GetPatientDetailsByDate(fromdate, todate): Observable<any> {
    return this.http.get<any>(`${configuration.clinicapiUrl + 'Encounter/GetPatientDetailsByDate'}?fromdate=${fromdate}&&todate=${todate}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  DeleteClinicalDataExport(id: string): Observable<any> {
    return this.http.delete<any>(`${configuration.clinicapiUrl + 'Encounter/DeleteClinicalDataExport'}?ID=${id}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  GetPatientXDM(patid: string): Observable<any> {
    return this.http.get<any>(`${configuration.clinicapiUrl + 'Encounter/GenerateXDM'}?Patient=${patid}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  generateNHCPSMessage(formdata: any, Messagetype: string): Observable<any> {
    const posteddata = {
      patientId: formdata.patientId,// sessionStorage.getItem("patientId"),
      encounterid: formdata.encounterid,// sessionStorage.getItem("encounterid"),
      userid: formdata.userid,// encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      dnisections: formdata.SectionswithComma,// SectionsList
      CCDAType: Messagetype
    };
    return this.http.post<any>(`${configuration.clinicapiUrl + 'Encounter/GetNHCPSMessage'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
    //  http://localhost:52622/api/Encounter/GetCCDAMessage const patientId: number=  parseInt(sessionStorage.getItem("patientId"));
    // const encounterID:string=sessionStorage.getItem("encounterid");
    //   return this.http.get<any>(
    //     `${configuration.clinicapiUrl + 'Encounter/GetCCDAMessage'}?patientId=${patientId}&&encounterid=${encounterID}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);


  }

}
